import Cookies from 'js-cookie';
const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

class CookieDb {
    constructor(config = {}) {
        this.config = {...config, ...this.defaults()};
        this.config.csrfToken = token;
    }

    defaults() {
        return {
            apiPath: '/api/path',
            cookieKeyName: 'key',
            expires: 2, // 2日間有効
            secure: location.protocol === 'https:',
        };
    }
    // 閲覧履歴の保存/削除
    async setState(target = 'cookie', id, state = true){
        if(!id) return false;
        switch (target) {
            case 'db': {
                const resp = await fetch(`${this.config.apiPath}/${id}`, {
                    method: state ? 'POST' : 'DELETE',
                    headers: {
                        'X-CSRF-TOKEN': this.config.csrfToken ,
                        'Content-Type': 'application/json',
                    },
                })
                .then(response => response.json());

                return 'error' in resp ? false : {
                    state,
                    total: resp.total,
                };
                break;
            }
            case 'cookie': {
                let items;
                try {
                    items = JSON.parse(Cookies.get(this.config.cookieKeyName) || "[]");
                    if (!Array.isArray(items)) items = [];
                } catch(e) {
                    items = [];
                }
                items = items.filter(item => item !== id);
                if (state) {
                    items.push(id);
                }
                Cookies.set(this.config.cookieKeyName, JSON.stringify(items), { expires: this.config.expires, secure: this.config.secure });
                return {
                    state,
                    total: items.length,
                }
                break;
            }
        }
    }

    async isState(target = 'cookie', id){
        const stateAll = await this.getAll(target);
        return stateAll.includes(id);
    }

    // すべての閲覧履歴を取得
    async getAll(target = 'cookie'){
        switch (target) {
            case 'db': {
                const resp = await fetch(`${this.config.apiPath}`, {
                    method: 'GET',
                    headers: {
                        'X-CSRF-TOKEN': this.config.csrfToken ,
                        'Content-Type': 'application/json',
                    },
                })
                .then(response => response.json());

                return 'error' in resp ? false : resp.items;
                break;
            }
            case 'cookie': {
                try {
                    const items = JSON.parse(Cookies.get(this.config.cookieKeyName) || "[]");
                    return Array.isArray(items) ? items : [];
                } catch(e) {
                    return [];
                }
            }
        }
    }

    // いいねのcookieを全削除
    resetAllCookie(){
        Cookies.remove(this.config.cookieKeyName);
    }
}

export default CookieDb;
